const Login = () => import('Views/login/login');
const ForgetPassword = () => import('Views/login/forget-password');

export default[
  { path: '/admin/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Login },
  { path: '/forget-password', name: 'forgetPassword', component: ForgetPassword },
];



// WEBPACK FOOTER //
// ./src/router/login.js